import { Col, Row } from 'components';
import { theme } from 'lib';

const Header = ({ children }) => {
  return (
    <Col pos="fixed" top="0" style={{ zIndex: 4 }}>
      {/* Width spans the entire content area: viewport minus the 190px admin sidebar. */}
      <Row center between pad="12px 24px" bg={theme.GREY_30} wid="calc(100vw - 190px)">
        {children}
      </Row>
    </Col>
  );
};

export default Header;
